import { useSelector } from "react-redux";
import Tooltip from "../../../../components/tooltip";
import SimulationTable from "./SimulationTable";
import SimulationSummaryAnylysis from "./SimulationSummaryChart";
import SimulationContributorAnylysis from "./SimulationContributor";
import SimulationModHeader from "./SimulationModHeader";
import { useState } from "react";
// import ToggleTabs from "../Mod/ModTable/ChartTableToggle";
// import SimulationStationAnylysis from "./SimulationStationChart";
import loader from "../../../../components/recharts/loader.gif";
import CostRuvnlSimulationIndex from "./CostSimulationIndex";
import BidRuvnlSimulationIndex from "./BidSimulationIndex";
import { useMeritEngineNavigation } from "../useMeritEngineNavigation";
import MainHeader from "../DateSession";
import { ErrorPopup } from "../../../../components/ErrorHandling";
// const DataTabs = ["summary", "station"];
const DataTabs = ["GENERATION", "COST", "BID"];
export default function ModRuvnlSimulationIndex() {
  const { navigateToPage } = useMeritEngineNavigation();
  const [error, setError] = useState<string | null>(null);
  const preSelectedDate = useSelector(
    (state: any) => state.modRuvnlDate.selectedDate,
  );
  // const modSelectedSession = useSelector(
  //   (state: any) => state.modRuvnlSession.modSession
  // );
  const [open, setOpen] = useState(true);

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(DataTabs[0]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedBlock, setSelectedBlock] = useState<any[]>([]);
  const [selectedGeneratorName, setSelectedGeneratorName] = useState<any[]>([]);

  return (
    <>
      <div className="w-full">
        <MainHeader />
        <div className="tabContent">
          <div className="h-[calc(-85px+100vh)] p-4">
            <div className="w-full h-full flex flex-col gap-4">
              <SimulationModHeader
                title={open ? "MeritEngine Simulator" : "Simulation Console"}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
              <div className=" flex flex-row gap-4 relative">
                <SimulationTable
                  open={open}
                  setOpen={setOpen}
                  setError={setError}
                  refreshKey={refreshKey}
                  setRefreshKey={setRefreshKey}
                  selectedBlock={selectedBlock}
                  setSelectedBlock={setSelectedBlock}
                  selectedGeneratorName={selectedGeneratorName}
                  setSelectedGeneratorName={setSelectedGeneratorName}
                />
                {activeTab === "GENERATION" && (
                  <div
                    className="load-data grid grid-cols-2 bg-white p-2 md:grid-cols-12 grid-rows-full md:grid-rows-2 gap-2 h-full w-full md:overflow-hidden  shadow-[rgba(149,157,165,0.2)_0px_8px_24px] rounded-2xl"
                    style={{
                      height: "calc(-195px + 100vh)",
                      width: "100%",
                      marginLeft: "29%",
                      filter: open ? "blur(0px)" : "blur(2px)",
                      position: "relative",
                      pointerEvents: open ? "auto" : "none",
                      zIndex: "0",
                    }}
                  >
                    <div className="dash-card col-span-1 md:col-span-12 border border-[#718EBF1C] !bg-[#fff] !shadow-[rgba(149,157,165,0.2)_0px_8px_24px] !min-h-[100%] w-full">
                      <div className="flex justify-between items-center mb-3">
                        <h2 className="chartHeading w-60">
                          Demand-Supply Balance
                        </h2>
                        {/* <div className="flex items-center gap-3">
                      <ToggleTabs
                        tabs={DataTabs}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                      />
                    </div> */}
                      </div>
                      {loading ? (
                        <div className="h-full w-full bg-white flex items-center justify-center">
                          <img
                            src={loader}
                            width={200}
                            alt="loader"
                            className="block mt-[5rem]"
                          />
                        </div>
                      ) : (
                        <>
                          <SimulationSummaryAnylysis
                            selectedBlock={selectedBlock}
                            selectedGeneratorName={selectedGeneratorName}
                            refreshKey={refreshKey}
                            setError={setError}
                          />
                        </>
                      )}
                    </div>
                    <SimulationContributorAnylysis
                      selectedBlock={selectedBlock}
                      selectedGeneratorName={selectedGeneratorName}
                      refreshKey={refreshKey}
                      setError={setError}
                    />
                  </div>
                )}
                {activeTab === "COST" && (
                  <CostRuvnlSimulationIndex
                    open={open}
                    selectedBlock={selectedBlock}
                    selectedGeneratorName={selectedGeneratorName}
                    refreshKey={refreshKey}
                    setError={setError}
                  />
                )}
                {activeTab === "BID" && (
                  <BidRuvnlSimulationIndex
                    open={open}
                    selectedBlock={selectedBlock}
                    selectedGeneratorName={selectedGeneratorName}
                    refreshKey={refreshKey}
                    setError={setError}
                  />
                )}
              </div>
            </div>
          </div>

          <ErrorPopup error={error} onClose={() => setError(null)} />
          {activeTab === "GENERATION" && (
            <div className="gna-footer-container">
              <div className="grid grid-cols-3 justify-between gap-5 ">
                <Tooltip
                  note={
                    <p>
                      Default values and variable charges are auto-fetched from
                      system.
                    </p>
                  }
                  text="1. By default, the simulator averages variables across all blocks.  
                    2. Select a block from the filter to see block-specific values.
                    3. The proposed generator schedule meets demand using own generation in ascending order of variable charges.
                    4. Generator cost is calculated using variable charge and proposed schedule.
 "
                >
                  <p className="gna-footer-text">Source</p>
                </Tooltip>
                <p className="gna-footer-text col-span-1 text-center">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <strong className="gna-footer-text col-span-1 text-end">
                  Beta Version
                </strong>
              </div>
            </div>
          )}
          {activeTab === "COST" && (
            <div className="gna-footer-container">
              <div className="grid grid-cols-3 justify-between gap-5 ">
                <Tooltip
                  note={
                    <p>
                      Default values and variable charges are auto-fetched from
                      system.
                    </p>
                  }
                  text="1. Withdrawal quantum is the total generation capacity minus the must-run capacity.
    2. Sale quantum is the total of sale quantities across all bids.
    3. Sale revenue is the total of each bid's sale quantity multiplied by its bid price. "
                >
                  <p className="gna-footer-text">Source</p>
                </Tooltip>
                <p className="gna-footer-text col-span-1 text-center">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <strong className="gna-footer-text col-span-1 text-end">
                  Beta Version
                </strong>
              </div>
            </div>
          )}
          {activeTab === "BID" && (
            <div className="gna-footer-container">
              <div className="grid grid-cols-3 justify-between gap-5 ">
                <Tooltip
                  note={<p>System has computed only single bids.</p>}
                  text="1. Each block reflects the cumulative bid quantity and the average bid price."
                >
                  <p className="gna-footer-text">Source</p>
                </Tooltip>
                <p className="gna-footer-text col-span-1 text-center">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <strong className="gna-footer-text col-span-1 text-end">
                  Beta Version
                </strong>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
